export default {"src":"/_next/static/media/easyspeed.0e0aec88.svg","height":874,"width":1177,"blurWidth":0,"blurHeight":0};